import { useId } from "react";

type JourneyStep = { title: string; text: string };
type Props = {
  label: string;
  title: string;
  intro: string;
  steps: readonly JourneyStep[];
  note?: string;
};

/** The visit rhythm from the homepage, with editorial content owned by each service. */
export default function ServiceJourney({ label, title, intro, steps, note }: Props) {
  const headingId = useId();
  return (
    <section className="design-process-section design-service-journey" aria-labelledby={headingId}>
      <div className="max-w-[1400px] mx-auto design-visit-layout">
        <div className="design-visit-intro">
          <p className="text-brand-label">{label}</p>
          <h2 id={headingId}>{title}</h2>
          <p className="design-visit-aside">{intro}</p>
        </div>
        <ol className="design-visit-steps">
          {steps.map((step, index) => (
            <li key={step.title}>
              <span className="design-visit-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <div><h3>{step.title}</h3><p>{step.text}</p></div>
            </li>
          ))}
        </ol>
        {note && <p className="design-journey-note">{note}</p>}
      </div>
    </section>
  );
}
